import { Component, Input } from '@angular/core';
import { ButtonType } from '@rensa/shared/enums/button-type.enum';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.css']
})
export class ButtonComponent {
    @Input() style: ButtonType = ButtonType.FILLED_PRIMARY;
    @Input() disabled: boolean;

    getClass(): string {
        switch (this.style) {
            case ButtonType.FILLED_PRIMARY:
                return 'filled-primary';
            case ButtonType.FILLED_SECONDARY:
                return 'filled-secondary';
            case ButtonType.FILLED_TERTIARY:
                return 'filled-tertiary';
            case ButtonType.FILLED_DANGER:
                return 'filled-danger';
            case ButtonType.OUTLINED_PRIMARY:
                return 'outlined-primary';
            case ButtonType.OUTLINED_SECONDARY:
                return 'outlined-secondary';
            case ButtonType.OUTLINED_TERTIARY:
                return 'outlined-tertiary';
            case ButtonType.OUTLINED_TERTIARY:
                return 'outlined-danger';
        }
    }
}
